import dpr from './dpr';

const px = num => {
    return num / dpr;
};

export default px;
